import { Padding } from "@mui/icons-material";
import { alpha } from "@mui/material";
import { blue, orange, red } from "@mui/material/colors";

const styles = {
  skeletonMainContainer: {
    display: "flex",
    padding: "0px !important",
  },
  skeletonSecondaryContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  mainContainer: {
    backgroundColor: "white",
    borderRadius: "1rem",
    width: "100%",
    padding: "20px",
    marginBottom: "12px",
    gap: "10px",
    display: "flex",
    justifyContent: "center",
  },
  deleteCategoryButton: {
    width: '130px', 
    borderRadius: '0.5rem', 
    height: '38px', 
    color: '#FFFFFF',
    backgroundColor: red['A400'],
    '&:hover': {
      backgroundColor: red['A300'],
    }
  },
  editCategoryButton: {
    width: '130px', 
    borderRadius: '0.5rem', 
    height: '38px', 
    color: red['A400']
  },
  chipsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 1,
  },
  statusActiveChip: {
    fontSize: "1rem",
    color: '#53CA98',
    borderRadius: 40,
    backgroundColor: alpha('#53CA98', 0.1),
  },
  statusInactiveChip: {
    fontSize: "1rem",
    color: '#DB463C',
    borderRadius: 40,
    backgroundColor: alpha('#DB463C', 0.1),
  },
  notificationActiveChip: {
    fontSize: "1rem",
    color: blue[500],
    borderRadius: 40,
    backgroundColor: alpha(blue[500], 0.1),
  },
  notificationInactiveChip: {
    fontSize: "1rem",
    color: orange[500],
    borderRadius: 40,
    backgroundColor: alpha(orange[500], 0.1),
  },
  benefitsContainer: {
    width: '100%',
    padding: '4px 0px !important',
    display: 'flex',
    justifyContent: 'space-between',
  },
  benefitsTitle: {
    paddingBottom: '14px',
  }
};

export default styles;
